<template>
  <main-content>
    <kt-panel>
      <kt-panel-body>
        <Show-News-Panel v-if="status !== 'loading'" :query="newsById"></Show-News-Panel>
      </kt-panel-body>
    </kt-panel>
  </main-content>
</template>
<script>
import ShowNewsPanel from "./components/ShowNewsPanel";
import mainContent from "@/components/main-content";
import { mapState } from "vuex";
export default {
  components: {
    ShowNewsPanel,
    mainContent,
  },

  computed: {
    ...mapState("news", ["status", "newsById"]),
  },
};
</script>
<style scoped>
</style>